module.exports = __webpack_public_path__ + "media/images/sp/items/gift/kiribako_detail_03-a6ddab09c49d32e989aa149b70404a29.jpg";